import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { isFirstPartyFrame, THIRD_PARTY_PATTERNS, AD_NETWORK_DOMAINS, hasAdNetworkFrame } from './bugsnag_filters'

function getMeta(name) {
  const tag = document.querySelector(`meta[name="${name}"]`)
  return tag ? tag.content : undefined
}

const apiKey = 'a71ba2fe4f490eaa55cd905e14165121'

if (window.location.hostname.includes('mtggoldfish.com')) {
  Bugsnag.start({
    apiKey,
    onError: event => {
      event.setUser(getMeta('bugsnag-user-id'))

      // Drop errors that don't have any first-party JS frame in their stack.
      // This filters out:
      //  - Errors originating entirely from ad-network / 3rd-party scripts.
      //  - Inline onclick / event-attribute handlers injected by ads, which
      //    surface as stack frames whose `file` is just the page URL.
      //  - Errors caused by ad blockers blocking our analytics scripts (e.g.
      //    "track is not defined" from inline onclick handlers).
      const frames = event.errors?.[0]?.stacktrace ?? []
      if (!frames.some(isFirstPartyFrame)) return false
      // Drop errors where an ad-network script appears in the stack, even if a
      // first-party frame is present (e.g. @bugsnag/request-tracker-performance
      // is webpack-bundled so it counts as first-party, letting ad-script
      // "Failed to fetch" errors through).
      if (hasAdNetworkFrame(frames)) return false

      const errorMessage = event.errors?.[0]?.errorMessage ?? ''
      if (THIRD_PARTY_PATTERNS.some(pattern => pattern.test(errorMessage))) return false
      if (AD_NETWORK_DOMAINS.test(errorMessage)) return false

      return true
    }
  })

  BugsnagPerformance.start({ apiKey })
}
